import cx from "classnames";

import { AgaveLogo } from "agavepulse/branding/AgaveLogo";
import CS from "metabase/css/core/index.css";
import { PLUGIN_LOGO_ICON_COMPONENTS } from "metabase/plugins";

interface LogoIconProps {
  width?: number;
  height?: number;
  dark?: boolean;
  fill?: string;
}

export const DefaultLogoIcon = ({
  dark,
  height = 32,
  width,
}: LogoIconProps) => {
  // The AGAVE badge, rendered from the official favicon artwork so the nav mark and the
  // browser-tab icon are the same image. `dark` and `fill` are accepted for call-site
  // compatibility but unused: the badge carries its own dark circle and fixed colors
  // rather than inheriting `currentColor` the way a path-based mark would.
  return (
    <AgaveLogo
      size={height}
      className={cx("Icon", { [CS.textWhite]: dark })}
      width={width}
      data-testid="main-logo"
    />
  );
};

export function LogoIcon(props: LogoIconProps) {
  const [Component = DefaultLogoIcon] = PLUGIN_LOGO_ICON_COMPONENTS;
  return <Component {...props} />;
}
